import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const alertVariants = cva(
  "relative overflow-hidden rounded-[16px] border px-5 py-4 shadow-sm backdrop-blur-md [&>*]:relative",
  {
    variants: {
      variant: {
        success: "border-kin-green/20 bg-kin-green/10 text-kin-green-dark",
        info: "border-kin-olive/20 bg-kin-white/60 text-kin-dark",
        warning: "border-kin-gold/30 bg-kin-gold/10 text-kin-black",
        error: "border-kin-rose/30 bg-kin-rose/10 text-kin-rose-dark",
      },
    },
    defaultVariants: {
      variant: "success",
    },
  },
);

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div className={cn(alertVariants({ variant, className }))} ref={ref} {...props} />
));

Alert.displayName = "Alert";

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("text-sm font-semibold tracking-[0.01em]", className)} {...props} />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("mt-1 text-sm leading-relaxed text-current opacity-90", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
